module.exports = __webpack_public_path__ + "static/img/bg-zhengcejiedu.4f2a601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcxj/bg-zhengcejiedu.png
// module id = 1607
// module chunks = 0